import React from 'react';
import { reviewStatus } from '../../../constants/misc';
import styles from './Review.module.scss';
import { Text } from '../../../components/typography';
import { getLocalTime } from '../../../utilities/time';
import { keys } from '../../../utilities/translator/translation_keys';
import { useTranslation } from 'react-i18next';

export default function Review({
  reviewer,
  editable = true,
  deletable = true,
  onEditClick,
  onCancelEdit,
  onDelete,
  isEditing,
}) {
  const { t } = useTranslation();
  if (reviewer.status === reviewStatus.open) {
    return null;
  }

  const getReviewMessage = (user, status, feedback) => {
    const actions = {
      [reviewStatus.approved]: t(keys.review_footer.APPROVED),
      [reviewStatus.changeRequest]: t(keys.review_footer.REQUESTED_CHANGES),
    };

    return (
      <div className={styles.reviewContainer}>
        <img
          className={styles.avatar}
          src={reviewer.user.avatarUrl}
          alt={`${reviewer.user.firstName} ${reviewer.user.lastName}`}
        />
        <div className={editable ? styles.editContainer : null}>
          <a href={`/user/${user.id}`} className={styles.userLink}>
            {`${user.firstName} ${user.lastName}`}
          </a>{' '}
          {actions[status]}. {t(keys.review_footer.FEEDBACK)}:{' '}
          <span className={styles.feedback}>"{feedback}"</span>.
          <Text size="sm" color="secondary" weight="semiBold">
            {getLocalTime(reviewer.dateModified).format(
              'MMMM Do YYYY, h:mm:ss a',
            )}
          </Text>
        </div>
        {deletable && !editable && (
          <Text
            className={styles.link}
            size="sm"
            weight="semiBold"
            color="red"
            onClick={onDelete}
          >
            {t(keys.action.DELETE)}
          </Text>
        )}
        {editable && (
          <Text
            className={styles.link}
            size="sm"
            weight="semiBold"
            color="blue"
            onClick={isEditing ? onCancelEdit : onEditClick}
          >
            {isEditing
              ? t(keys.review_footer.CANCEL_EDIT)
              : t(keys.review_footer.EDIT_REVIEW)}
          </Text>
        )}
      </div>
    );
  };

  const message = getReviewMessage(
    reviewer.user,
    reviewer.status,
    reviewer.notes,
  );

  return <div className={styles.notificationMessage}>{message}</div>;
}
